import { ReportBuilderAPI } from '@business/api/reportBuilder';
import { ReportAdditionalData, ReportDataQuery, ReportDataType } from '@business/entities/dynamicReprots';
import { BaseBloc } from '@core/utils/bloc';
import { PaginatedController } from '@core/utils/paginated';
import { LoadingState } from '@core/utils/repository/loading_state';

export class ReportViewerBloc extends BaseBloc {
  loading = new LoadingState();

  fetchFn = (query: ReportDataQuery) => {
    return ReportBuilderAPI.getData(query).pipe(this.loading.run());
  };

  readonly paginated = new PaginatedController<ReportDataType, string, ReportDataQuery, ReportAdditionalData>(this.fetchFn, '', {
    page: 1,
  });

  data$ = this.paginated.items$;
  additional$ = this.paginated.additional$;

  downloadCSV = (filename: string) => {
    const query = this.paginated.pageQuery$.value;
    ReportBuilderAPI.downloadCSV(query, filename).subscribe();
  };
}
